import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import DriverTagsList from "../../components/DriverTags/DriverTagsList";
import ListPagination from "../../components/Common/ListPagination";
import DriverTagsFormModal from "../../components/DriverTags/DriverTagsFormModal";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverTagsActions from "../../store/actions/DriverTags";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import FilterButton from "../../components/Common/FilterButton";
import { FlexContainer, Heading } from "../../constants/assets/containers";

const DriverTags = (props) => {
  const { getDriverTagsList, driverTagsList } = props;
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.DRIVER_TAG];

  const filterFields = ["name", "tag_type"];

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getDriverTagsList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getDriverTagsList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <DriverTagsFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <DriverTagsFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      case "Bulk":
        return (
          <DriverTagsFormModal
            isBulkUpload={true}
            modalState={"Add"}
            handleClose={handleClose}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    getDriverTagsList();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="Driver-Tags-View container">
      <FlexContainer align="flex-start">
        <Heading>Driver Tags</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="tagsAddBtn"
            >
              Add New
            </Button>
          </Permission>
          <Permission
            optionalPerms={[
              allActions.BULK_UPLOAD_OTHER_TAG,
              allActions.BULK_UPLOAD_FUTURE_ACCOUNTING_TAG,
            ]}
          >
            <Button
              onClick={() => handleClick("Bulk")}
              className="sushi-btn ml-12"
              data-testid="BulkUploadTagsBtn"
            >
              Bulk Upload Driver Tags Mappings
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <DriverTagsList
        driverTagsList={driverTagsList}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverTags } = state;
  return {
    driverTagsList: DriverTags.driverTagsList,
    nextPage: DriverTags.nextPage,
    prevPage: DriverTags.prevPage,
    activeFilters: DriverTags.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverTagsList: bindActionCreators(
      DriverTagsActions.getDriverTagsList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverTags);
